import { useQuery } from '@tanstack/react-query';

import { getCartUpSellsCarousel, getPDPUpSellsCarousel, getPLPUpSellsCarousel } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const UP_SELLS_CAROUSEL_QUERY_KEY = 'upsells-carousel';

const useUpSellsCarouselQuery = ({ position, sellableItemID, type }) => {
    const { data: account } = useAccountQuery();

    const chargeID = account?.nextOrder?.chargeID;
    // Cart-upsells API has no `type`; omit from cache key for that path only.
    const queryKey = sellableItemID
        ? [UP_SELLS_CAROUSEL_QUERY_KEY, chargeID, position, sellableItemID, type]
        : [UP_SELLS_CAROUSEL_QUERY_KEY, chargeID, position, null];

    const query = useQuery({
        queryKey,
        queryFn: async () => {
            let response = {};

            if (sellableItemID) {
                if (position === 'inline') {
                    response = await getPDPUpSellsCarousel({ chargeID: account?.nextOrder?.chargeID, sellableItemID });
                } else {
                    response = await getPLPUpSellsCarousel({ chargeID: account?.nextOrder?.chargeID, sellableItemID });
                }
            } else {
                response = await getCartUpSellsCarousel({ chargeID: account?.nextOrder?.chargeID });
            }

            return response?.data;
        },
        enabled: !!account?.nextOrder?.chargeID,
        refetchOnWindowFocus: false,
    });

    return query;
};

export default useUpSellsCarouselQuery;
